// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__81IbC","dot":"index_dot__0rzYX","glow":"index_glow__5Q2jE"};